import VendorSuccess from './VendorSuccess.component';

export default VendorSuccess;
